module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/selfi2__19857792896a5221478c587c745a28fc.png";